import { enumPolicies } from '../../../_metronic/helpers/enumPolicies'
import { enumSystemPolicyType } from '../../../_metronic/helpers/enumSystemPolicyType'

export interface KioskPageAccess {
  path: string
  policies: number[]
  systemPolicyId?: number
}

/**
 * Single source of truth for which policies unlock which kiosk page.
 * KioskLayout (header buttons), KioskRouteGuard (routes) and KioskPage
 * (post-login landing) must all use this so they can never disagree.
 */
export const KIOSK_PAGES: KioskPageAccess[] = [
  {
    path: '/kiosk/production',
    policies: [enumPolicies.ManufacturedProductRead],
  },
  {
    path: '/kiosk/stocks',
    policies: [enumPolicies.StockRead, enumPolicies.StockEdit, enumPolicies.StockWrite],
    systemPolicyId: enumSystemPolicyType.StockControl,
  },
]

/**
 * systemPolicies === null/undefined means "not loaded yet" — only the user
 * policies are checked then; the route guard re-evaluates once they arrive.
 */
export const canAccessKioskPage = (
  page: KioskPageAccess,
  policyIds?: number[] | null,
  systemPolicies?: number[] | null
): boolean => {
  const ids = policyIds || []
  if (!page.policies.some((p) => ids.includes(p))) return false
  if (page.systemPolicyId != null && systemPolicies && !systemPolicies.includes(page.systemPolicyId)) return false
  return true
}

export const findKioskPage = (pathname: string): KioskPageAccess | undefined =>
  KIOSK_PAGES.find((p) => pathname === p.path || pathname.startsWith(`${p.path}/`))

/** First kiosk page this user may see, or null when none. */
export const getKioskLandingPath = (
  policyIds?: number[] | null,
  systemPolicies?: number[] | null
): string | null => {
  const page = KIOSK_PAGES.find((p) => canAccessKioskPage(p, policyIds, systemPolicies))
  return page ? page.path : null
}
